var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "white",
    stroke: "#217EE2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.846 11.5L10.3717 13.8535C10.1665 14.0488 9.83366 14.0488 9.62833 13.8535L7.15392 11.5C6.94869 11.3047 6.94869 10.9882 7.15392 10.7929C7.35924 10.5976 7.69209 10.5976 7.89742 10.7929L9.47442 12.2929L9.47441 6.5C9.47441 6.2239 9.7097 6 10 6C10.2904 6 10.5257 6.2239 10.5257 6.5L10.5257 12.2929L12.1026 10.7929C12.3079 10.5976 12.6407 10.5976 12.846 10.7929C13.0513 10.9882 13.0513 11.3047 12.846 11.5Z",
    fill: "#217EE2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleDownload);
export default __webpack_public_path__ + "static/media/circle-download.5e0752e05de0152a0baa93e5c4f53625.svg";
export { ForwardRef as ReactComponent };